export function installGlobalProdDebug() {
  if (typeof window === 'undefined') return;

  function banner(kind: string, msg: string) {
    const el = document.createElement('div');
    el.style.cssText = 'position:fixed;z-index:99999;top:0;left:0;right:0;background:#111;color:#fff;padding:8px 12px;font:12px/1.4 monospace';
    el.textContent = `[${kind}] ${msg}`;
    document.body.prepend(el);
  }

  window.addEventListener('error', (e) => {
    console.error('GlobalError:', (e as ErrorEvent).error || e.message || e);
    banner('ERROR', String((e as ErrorEvent).error?.message ?? e.message ?? e));
  });

  window.addEventListener('unhandledrejection', (e: PromiseRejectionEvent) => {
    console.error('UnhandledRejection:', e.reason);
    banner('REJECTION', String((e.reason as any)?.message ?? e.reason));
  });

  const info = {
    MODE: import.meta.env.MODE,
    VITE_API_BASE: (import.meta as any).env?.VITE_API_BASE || '',
  };
  console.log('[RUNTIME_ENV]', info);
}

